import { render, staticRenderFns } from "./DemographicsRace.vue?vue&type=template&id=f437382c&scoped=true"
import script from "./DemographicsRace.vue?vue&type=script&lang=js"
export * from "./DemographicsRace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f437382c",
  null
  
)

export default component.exports